module.exports = __webpack_public_path__ + "static/media/Data3.3ee5bdc7.png";